import React from "react";
import { FallbackProps } from "react-error-boundary";
import { Text } from "@local-logic/core/ui";
import * as styles from "./styles";

const ErrorFallback: React.FC<FallbackProps> = ({ error }) => (
  <div className={styles.container} data-testid="error-fallback">
    <Text variant="h4">An error occurred</Text>
    <Text variant="p" color="--ll-color-on-background-variant1">
      {error.message}
    </Text>
  </div>
);

export default ErrorFallback;
